import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d9352d6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid h-auto" }
const _hoisted_2 = { class: "col-12 sm:col-2 md:col-1" }
const _hoisted_3 = { class: "subject-title" }
const _hoisted_4 = { class: "subject-title-text" }
const _hoisted_5 = { class: "col-12 sm:col-6 md:col-6 flex flex-column gap-2" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "highSchool",
  class: "font-medium"
}, "Tên trường", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { id: "highSchool-help" }, null, -1))
const _hoisted_8 = { class: "col-12 sm:col-3 md:col-2 flex flex-column gap-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "highSchool",
  class: "font-medium"
}, [
  /*#__PURE__*/_createTextVNode("Địa chỉ"),
  /*#__PURE__*/_createElementVNode("small", null, [
    /*#__PURE__*/_createElementVNode("i", null, " (huyện (quận), tỉnh (thành phố))")
  ])
], -1))
const _hoisted_10 = { class: "col-12 sm:col-2 md:col-1 flex flex-column gap-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "highSchool",
  class: "font-medium"
}, "Mã tỉnh (Tp)", -1))
const _hoisted_12 = { class: "col-12 sm:col-2 md:col-1 flex flex-column gap-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "highSchool",
  class: "font-medium"
}, "Mã huyện (quận)", -1))
const _hoisted_14 = { class: "col-12 sm:col-3 md:col-1 flex flex-column gap-2" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "highSchool",
  class: "font-medium"
}, "Mã trường", -1))

import { computed, ref } from 'vue';
import LazyDropdown from './LazyDropdown.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NoiHoc',
  props: {
    name: {},
    code: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;




const highSchool = computed({
    get: () => props.modelValue,
    set: (val: any) => {
        emit('update:modelValue', val);
    }
});

const title = computed(() => {
    return { 'CLASS_10': 'Lớp 10', 'CLASS_11': 'Lớp 11', 'CLASS_12': 'Lớp 12' }[props.code];
})
const highSchoolCode = computed(() => {
    return highSchool.value && highSchool.value.metadata ? highSchool.value.metadata.code : '';
});
const highSchoolAddress = computed(() => {
    return highSchool.value && highSchool.value.metadata ? highSchool.value.metadata.address : '';
});
const provinceCode = computed(() => {
    return highSchool.value && highSchool.value.metadata ? highSchool.value.metadata.provinceCode : '';
});
const districtCode = computed(() => {
    return highSchool.value && highSchool.value.metadata ? highSchool.value.metadata.districtCode : '';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(title.value), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createVNode(LazyDropdown, {
        id: "highSchool",
        modelValue: highSchool.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((highSchool).value = $event)),
        "option-label": "text",
        "aria-describedby": "highSchool-help",
        requiredMessage: 'Tên trường '+ title.value + ' bắt buộc phải nhập ',
        url: "/helper/high-school/options",
        name: _ctx.name
      }, null, 8, ["modelValue", "requiredMessage", "name"]),
      _hoisted_7
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createTextVNode(" " + _toDisplayString(highSchoolAddress.value), 1)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createTextVNode(" " + _toDisplayString(provinceCode.value), 1)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createTextVNode(" " + _toDisplayString(districtCode.value), 1)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _createTextVNode(" " + _toDisplayString(highSchoolCode.value), 1)
    ])
  ]))
}
}

})